import { datadogRum } from '@datadog/browser-rum-slim';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';

const shouldUseDatadog = (currentEnv) => {
    return currentEnv === EBEnvs.PROD || currentEnv === EBEnvs.QA;
};

export const initializeRum = (props) => {
    const currentEnv = getCurrentEnv(props);
    const useDatadog = shouldUseDatadog(currentEnv);

    if (useDatadog) {
        const sampleRate = currentEnv == EBEnvs.PROD ? 15 : 100;

        initializeRealUserMonitoring({
            sessionSampleRate: sampleRate,
            version: props.app_version,
            service: props.app_name,
            env: currentEnv || undefined,
            enableExperimentalFeatures: ['feature_flags'],
        });

        datadogRum.onReady(() => {
            if (props?.user?.email) {
                const datadogRumUser = {
                    email: props.user.email,
                    id: props.user.publicId,
                };

                datadogRum.setUser(datadogRumUser);
            }
        });
    }
};
